import { cn } from "@/modules/lib/utils"

type BoxOfferRuleCardProps = {
  className?: string
} & React.ComponentProps<"div">

export function BoxOfferRuleCard({ children, className, ...props }: BoxOfferRuleCardProps) {
  return (
    <div className={cn("flex h-[7rem] items-center gap-2 rounded-[1.25rem] px-8 py-7", className)} {...props}>
      {children}
    </div>
  )
}
